import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import {
  SupplyStatus,
  supplyAppSelectionSchema,
  supplyDomainSelectionSchema,
  type TailoredSupplyPayload,
} from './model';

const requiredString = z.string().trim().min(1, dashboardT('supply.required'));

export const supplyAppFormSchema = z.object({
  name: requiredString,
  bundleId: requiredString,
  appStoreId: z.string(),
  appStoreUrl: z.string(),
  domain: z.string(),
  platformId: requiredString,
  status: z.enum(SupplyStatus),
  iabCategories: z.array(z.string()),
});

export const supplyDomainFormSchema = z.object({
  url: requiredString,
  status: z.enum(SupplyStatus),
  iabCategories: z.array(z.string()),
});

export const tailoredSupplyFormSchema = z
  .object({
    name: requiredString.max(255),
    description: z.string(),
    apps: z.array(supplyAppSelectionSchema),
    domains: z.array(supplyDomainSelectionSchema),
  })
  .superRefine((value, context) => {
    if (!value.apps.length && !value.domains.length) {
      context.addIssue({
        code: 'custom',
        path: ['apps'],
        message: dashboardT('supply.selectionRequired'),
      });
    }
  });

export type SupplyAppFormValue = z.infer<typeof supplyAppFormSchema>;
export type SupplyDomainFormValue = z.infer<typeof supplyDomainFormSchema>;
export type TailoredSupplyFormValue = z.infer<typeof tailoredSupplyFormSchema>;

export function serializeTailoredSupplyFormValue(
  value: TailoredSupplyFormValue,
  id?: string,
): TailoredSupplyPayload {
  return {
    ...(id ? { id } : {}),
    name: value.name.trim(),
    description: value.description.trim(),
    apps: value.apps.map(({ id: appId }) => ({ id: appId })),
    domains: value.domains.map(({ id: domainId }) => ({ id: domainId })),
  };
}
